<script setup lang="ts">

</script>


<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage :keepalive="{ max: 3 }" />
    </NuxtLayout>
  </UApp>
</template>


<style scoped lang="scss"></style>